import DesNavigateContentAsListViewModel from 'viewmodel/DesNavigateContentAsListViewModel'
import { DesBaseCatalogAcc } from '../utils/des-base-catalog-acc';

export default class DesNavigateContentAsList extends DesBaseCatalogAcc {
    constructor() {
        super(DesNavigateContentAsListViewModel);
    }

    get containerType() {
        return this.getAttribute('containertype') || this.getAttribute('container-type');
    }

    get containerId() {
        return this.getAttribute('containerid') || this.getAttribute('container-id');
    }

    get folderId() {
        return this.getAttribute('folderid') || this.getAttribute('folder-id');
    }

    get filterType() {
        const filterType = this.getAttribute('showfoldersonly') || this.getAttribute('show-folders-only');
        let type = false;
        if (filterType === 'true') {
            type = true;
        }
        return type;
    }

    get locale() {
        return this.getAttribute('locale') || 'en_US';
    }

    getProps() {
        return {
            containertype: this.containerType,
            containerid: this.containerId,
            folderid: this.folderId,
            showfoldersonly: this.filterType
        };
    }

    static get observedAttributes() {
        return [...DesBaseCatalogAcc.observedAttributes, 'locale',
        'containertype', 'container-type',
        'containerid', 'container-id',
        'folderid', 'folder-id',
        'showfoldersonly', 'show-folders-only',
    ];
    }
}

if (!window.customElements.get('des-navigate-content-as-list')) {
    window.customElements.define('des-navigate-content-as-list', DesNavigateContentAsList);
}
